const downloadFlag = Object.freeze({
  chart: true,
  pdf: true,
  data: true,
});

export default downloadFlag;
